import { useState } from 'react'
import { BottomSheet } from './BottomSheet.jsx'
import { useIsDesktop } from '../useIsDesktop.js'

// Read-only select with a bottom-sheet picker on mobile, native <select>
// on desktop. `options` = [{ value, label }]. The trigger renders a button
// styled by `triggerClassName` (so it can adopt the host's input look) plus
// a small caret.
export function SimpleSelect({
  value, options, onChange,
  triggerClassName = '',
  className = '',
  ariaLabel,
  title,
  closeLabel = 'Close',
}) {
  const isDesktop = useIsDesktop()
  if (isDesktop) {
    return (
      <select
        className={triggerClassName || className}
        value={value}
        onChange={e => onChange(e.target.value)}
        aria-label={ariaLabel}
      >
        {options.map(o => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    )
  }
  return (
    <Mobile
      value={value}
      options={options}
      onChange={onChange}
      triggerClassName={triggerClassName || className}
      ariaLabel={ariaLabel}
      title={title}
      closeLabel={closeLabel}
    />
  )
}

function Mobile({ value, options, onChange, triggerClassName, ariaLabel, title, closeLabel }) {
  const [open, setOpen] = useState(false)
  const selected = options.find(o => o.value === value)
  return (
    <>
      <button
        type="button"
        className={`ss-trigger ${triggerClassName}${open ? ' open' : ''}`}
        onClick={() => setOpen(true)}
        aria-label={ariaLabel}
      >
        <span className="ss-trigger-label">{selected?.label ?? value}</span>
        <span className="ss-trigger-caret" aria-hidden="true">▾</span>
      </button>
      <BottomSheet open={open} onClose={() => setOpen(false)} className="ss-sheet">
        {title && (
          <div className="ss-header">
            <span className="ss-h-title">{title}</span>
            <button
              type="button"
              className="ss-h-close"
              onClick={() => setOpen(false)}
              aria-label={closeLabel}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
        )}
        <div className="ss-list" role="listbox">
          {options.map(o => (
            <button
              key={o.value}
              type="button"
              className={`ss-row${o.value === value ? ' selected' : ''}`}
              onClick={() => { onChange(o.value); setOpen(false) }}
            >
              {o.label}
            </button>
          ))}
        </div>
      </BottomSheet>
    </>
  )
}
